import { IconArrowBoldDown16, UIHeading2, UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { EPriceDiff } from '../../../../types';

export interface IPriceProps {
  diff?: EPriceDiff;
  subprice?: string | null;
  size?: 'M' | 'XS';
}

export const Price: React.FC<React.PropsWithChildren<IPriceProps>> = ({ children, diff, subprice, size }) => {
  const Heading = size === 'M' ? UIHeading2 : UIHeading4;

  return (
    <div>
      <div className={styles['price']}>
        <Heading>{children}</Heading>
        {diff && diff !== EPriceDiff.NoChange && (
          <div style={{ transform: diff === EPriceDiff.Increase ? 'rotate(180deg)' : undefined }}>
            <IconArrowBoldDown16 color={diff === EPriceDiff.Increase ? 'error_100' : 'success_100'} display="block" />
          </div>
        )}
      </div>
      {subprice && <UIText2 color="gray60_100">{subprice}</UIText2>}
    </div>
  );
};
